
import { CatalogosProps } from "../interfaces/catalogos/CatalogosInterface";

export const FiltroCatalogos = ( catalogos: CatalogosProps[] , value: string ) => {

    const catalogosFilter = catalogos.filter(function ({ descripcion }) { 

        const descripcionFilter = descripcion?.toLowerCase().indexOf(value.toLowerCase() );
        
        return descripcionFilter !== -1;
    });

    return catalogosFilter;
}